export const Pending: unique symbol = Symbol("Pending");
export const Unknown: unique symbol = Symbol("Unknown");
export const Failed: unique symbol = Symbol("Failed");
export type Pending = typeof Pending;
export type Unknown = typeof Unknown;
export type Failed = typeof Failed;
export type Result<T> = Pending | Unknown | Failed | T;
export function isResolved<T>(value: Result<T>): value is T {
	return value !== Pending && value !== Unknown && value !== Failed;
}
export function valueOrFailed<T>(value: Result<T>): value is T | Failed {
	return value !== Pending && value !== Unknown;
}
